export default __webpack_public_path__ + "static/Sumair-Jaffar-47b8f1a4211dbac099db5f1325e43c0a.jpg";